import { render, staticRenderFns } from "./personalSign.vue?vue&type=template&id=4f55b985&scoped=true"
import script from "./personalSign.vue?vue&type=script&lang=js"
export * from "./personalSign.vue?vue&type=script&lang=js"
import style0 from "./personalSign.vue?vue&type=style&index=0&id=4f55b985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55b985",
  null
  
)

export default component.exports